@let accessStatus = accessService.accessStatus | async;
@let activeLevel = layerStore.activeLevel | async;
@let activeLayer = layerStore.activeLayer | async;
@let isMapGroupAccessible =
  (mapColorFeatureList | isGroupAccessible: accessStatus) || !isPaidPlan;
@let isChartGroupAccessible =
  (chartFeatureList | isGroupAccessible: accessStatus) || !isPaidPlan;
@let isPlacesGroupAccessible =
  (placesFeatureList | isGroupAccessible: accessStatus) || !isPaidPlan;
@let isAnyGroupAccessible =
  isMapGroupAccessible || isChartGroupAccessible || isPlacesGroupAccessible;
@let userPlan = accessService.userPlan | async;
@let mapDisabled = accessService.isMapLoadingRestricted;

<div
  *ngIf="
    (activeMenuGroup === MAPS_GROUP &&
      groupData.data.mapColor &&
      isMapGroupAccessible) ||
    (activeMenuGroup === CHARTS_GROUP &&
      groupData.data.charts &&
      isChartGroupAccessible) ||
    (activeMenuGroup === PLACES_GROUP &&
      groupData.data.places &&
      isPlacesGroupAccessible) ||
    (activeMenuGroup === ALL_DATA_GROUP &&
      (groupData.data.places ||
        groupData.data.charts ||
        groupData.data.mapColor) &&
      isAnyGroupAccessible)
  "
  [ngClass]="{
    'layer-opened': isFeatureVisible,
    'filters-opened': isFiltersOpened,
  }"
  class="layers-info-container"
>
  <div class="layers-info-title" (click)="toggleGroup()">
    <button app-icon-button iconSize="10px">
      <app-icon
        [ngClass]="{ 'opened-arrow-icon': isFeatureVisible }"
        class="arrow-right-icon"
        svgIcon="arrow_right"
      >
      </app-icon>
    </button>
    {{
      groupData.title | groupTitleFormatter: (accessService.userPlan | async)
    }}
    <app-feature-tooltip
      *ngIf="groupData.tooltip"
      [tooltipText]="groupData.tooltip.text"
      [tooltipRouterLink]="groupData.tooltip.routerLink"
      (openTooltipModal)="handleTooltipModalOpen($event)"
    ></app-feature-tooltip>
  </div>

  <div
    class="scope-container"
    *ngIf="
      groupData.scope &&
      isFeatureVisible &&
      !(activeLevel === STATE_LEVEL_LAYER)
    "
  >
    <app-custom-radio-group
      [(ngModel)]="selectedScope"
      (change)="onScopeToggle($event)"
    >
      <app-custom-radio
        class="scope-radio-button"
        [value]="FeatureScope.BY_COUNTRY"
        [checked]="selectedScope === FeatureScope.BY_COUNTRY"
      >
        National
      </app-custom-radio>
      <app-custom-radio
        class="scope-radio-button"
        [value]="FeatureScope.BY_STATE"
        [checked]="selectedScope === FeatureScope.BY_STATE"
      >
        By state
      </app-custom-radio>
    </app-custom-radio-group>
  </div>

  <div
    *ngIf="
      isFeatureVisible &&
      (activeMenuGroup === MAPS_GROUP || activeMenuGroup === ALL_DATA_GROUP) &&
      groupData.data.mapColor
    "
    class="indexes-group-form toggle-wrapper"
  >
    <span
      class="poi-disclaimer"
      *ngIf="
        groupData.disclaimer &&
        (!groupData.disclaimer.visibleOnLevels ||
          groupData.disclaimer.visibleOnLevels?.includes(activeLevel!))
      "
      [attr.data-cy]="'visible-on-levels-disclaimer'"
      >{{ groupData.disclaimer.text }}</span
    >
    <ng-container
      *ngFor="let feature of groupData.data.mapColor; trackBy: identifyByConst"
    >
      <span
        class="poi-disclaimer"
        *ngIf="
          feature.disclaimer &&
          feature.disclaimer.visibleOnLevels?.includes(activeLevel!)
        "
        >{{ feature.disclaimer.text }}</span
      >

      <div
        [class.guide-highlight]="
          (guideService.highlightFeature$ | async) === feature.featureConst
        "
        [class.guide-highlight-pulse]="
          (guideService.highlightFeature$ | async) === feature.featureConst &&
          (guideService.highlightPulse$ | async)
        "
      >
        <app-custom-radio
          *ngIf="
            (!isPaidPlan && !feature.isAdminOnly) ||
            (isPaidPlan &&
              (feature.featureConst | isFeatureAccessible: accessStatus))
          "
          [checked]="
            groupData.scope
              ? activeLayer === feature.featureConst + selectedScope
              : activeLayer === feature.featureConst
          "
          (change)="
            onActiveLayerToggle(
              groupData.scope
                ? feature.featureConst + selectedScope
                : feature.featureConst
            )
          "
          (click)="
            handleRadioButtonClick();
            handleInaccessibleFeatureClick(
              feature.featureConst,
              feature.featureName
            )
          "
          class="menu-toggle"
          [value]="
            groupData.scope
              ? feature.featureConst + selectedScope
              : feature.featureConst
          "
          [disabled]="
            mapDisabled ||
            (feature.accessibleOnLevels &&
              !feature.accessibleOnLevels.includes(activeLevel!)) ||
            !(feature.featureConst | isFeatureAccessible: accessStatus) ||
            (accessService.isFeaturesClickLimitExceeded &&
              accessService.isUnauthorized)
          "
          [attr.data-cy]="feature.e2eName"
        >
          <span class="right-menu-category-elements">{{
            feature.featureConst | LayerNameFormatPipe: userPlan
          }}</span>

          <app-feature-tooltip
            *ngIf="feature.tooltip"
            [isFeatureInaccessibleType]="
              !(feature.featureConst | isFeatureAccessible: accessStatus)
            "
            [featureConst]="feature.featureConst"
            [featureName]="feature.tooltip.headerText"
            [headerText]="feature.tooltip.headerText"
            [tooltipText]="feature.tooltip.text"
            (openTooltipModal)="handleTooltipModalOpen($event)"
          ></app-feature-tooltip>
        </app-custom-radio>
        <app-colorscale
          *ngIf="
            groupData.scope
              ? activeLayer === feature.featureConst + selectedScope
              : activeLayer === feature.featureConst
          "
          [colors]="colorScaleService.colorScaleColors"
          class="colorscale"
        ></app-colorscale>
      </div>
    </ng-container>
  </div>

  <div
    class="charts-container toggle-wrapper"
    *ngIf="
      isFeatureVisible &&
      (activeMenuGroup === CHARTS_GROUP ||
        activeMenuGroup === ALL_DATA_GROUP) &&
      groupData.data.charts
    "
  >
    <ng-container
      *ngFor="let chart of groupData.data.charts; trackBy: identifyByConst"
    >
      <app-chart-block
        *ngIf="
          (!isPaidPlan && !chart.isAdminOnly) ||
          (isPaidPlan &&
            (chart.featureConst | isFeatureAccessible: accessStatus))
        "
        [chart]="chart"
        [featureStatus]="groupData.featureStatus!"
        [toggle]="layerDataService.toggleMap.get(chart.featureConst)!"
        (changeSelectedYear)="onSelectedYearChange($event)"
        (click)="
          handleInaccessibleFeatureClick(chart.featureConst, chart.toggleTitle)
        "
        [disabled]="
          mapDisabled ||
          !(chart.featureConst | isFeatureAccessible: accessStatus) ||
          (accessService.isFeaturesClickLimitExceeded &&
            accessService.isUnauthorized)
        "
      ></app-chart-block>
    </ng-container>
  </div>

  <div
    class="charts-container toggle-wrapper"
    *ngIf="
      isFeatureVisible &&
      (activeMenuGroup === PLACES_GROUP ||
        activeMenuGroup === ALL_DATA_GROUP) &&
      groupData.data.places
    "
  >
    <app-feature-disclaimer
      *ngIf="
        groupData.disclaimer &&
        layerStore.currentZoom! < groupData.disclaimer.visibleOnZoom?.min!
      "
      [disclaimer]="groupData.disclaimer"
    ></app-feature-disclaimer>

    <ng-container
      *ngFor="
        let feature of $any(groupData.data.places);
        trackBy: identifyByConst
      "
    >
      @let toShowFeature =
        (!isPaidPlan && !feature.isAdminOnly) ||
        (isPaidPlan &&
          (feature.featureConst | isFeatureAccessible: accessStatus));

      <app-feature-disclaimer
        *ngIf="
          feature.disclaimer &&
          layerStore.currentZoom! < feature.disclaimer.visibleOnZoom?.min! &&
          toShowFeature
        "
        [disclaimer]="feature.disclaimer"
      ></app-feature-disclaimer>

      <app-slide-toggle
        [formControl]="
          layerDataService.placesToggleMap.get(feature.featureConst)!
        "
        *ngIf="toShowFeature && groupData.title !== POI_GROUP_TITLE"
        (change)="handlePointsToggleChange($event)"
        [disabled]="
          mapDisabled ||
          !(feature.featureConst | isFeatureAccessible: accessStatus)
        "
      >
        {{ $any(feature).featureName }}
        <app-feature-tooltip
          [tooltipText]="feature.tooltip.text"
          [isFeatureInaccessibleType]="
            !(feature.featureConst | isFeatureAccessible: accessStatus)
          "
          [headerText]="feature.tooltip.headerText"
          [featureConst]="feature.featureConst"
          [featureName]="feature.featureName || feature.toggleTitle"
          (openTooltipModal)="handleTooltipModalOpen($event)"
        ></app-feature-tooltip>
      </app-slide-toggle>

      <app-chart-block
        *ngIf="$any(feature).toggleTitle && toShowFeature"
        [chart]="$any(feature)"
        [featureStatus]="groupData.featureStatus!"
        [toggle]="
          groupData.title === POI_GROUP_TITLE
            ? layerDataService.placesToggleMap.get($any(feature).featureConst)!
            : layerDataService.toggleMap.get($any(feature).featureConst)!
        "
        (changeSelectedYear)="onSelectedYearChange($event)"
        (click)="
          handleInaccessibleFeatureClick(
            feature.featureConst,
            feature.featureName || feature.toggleTitle
          )
        "
        [disabled]="
          mapDisabled ||
          !(feature.featureConst | isFeatureAccessible: accessStatus)
        "
      ></app-chart-block>

      @let schoolCtrl = layerDataService.placesToggleMap.get(SCHOOLS_POI);
      @let oriCtrl = layerDataService.placesToggleMap.get(ORI_LAYER);
      @let isSchoolToggleActive =
        groupData.title === EDUCATION_GROUP_TITLE && schoolCtrl?.value;
      @let isOriToggleActive =
        groupData.title === CRIME_GROUP_TITLE && oriCtrl?.value;

      <app-nearest-poi-panel
        *ngIf="isSchoolToggleActive || isOriToggleActive"
        [isSchool]="isSchoolToggleActive"
        [isOri]="isOriToggleActive"
      >
      </app-nearest-poi-panel>
    </ng-container>
  </div>
</div>
